import React, { useState, useEffect, useContext } from 'react';

import { GGChartContext } from '@gogame/components';

import AnnotationList from './AnnotationList';
import AnnotationsForm from './AnnotationsForm';
import { SlideBlock } from './components';
import { ANNOTATIONS_SETTINGS_SHOW } from './constants';

const FORM_VIEW_KEY = 'form';
const LIST_VIEW_KEY = 'list';

const Annotations = ({ settings, items, period, onShow, onClose }) => {
  const {
    selectedAnnotations: ids,
    selectedCategoryDate: date,
    selectAnnotations,
    highlightPeriod,
  } = useContext(GGChartContext);

  const showAnnotation = settings[ANNOTATIONS_SETTINGS_SHOW];
  const [activeViewKey, setActiveViewKey] = useState(
    showAnnotation ? LIST_VIEW_KEY : FORM_VIEW_KEY
  );

  const [open, setOpen] = useState(true);

  const handleToggle = () => setOpen((o) => !o);

  const handleSubmit = (values) => {
    onShow(values);
    setActiveViewKey(LIST_VIEW_KEY);
  };

  const handleOpenFilters = () => setActiveViewKey(FORM_VIEW_KEY);

  const handleHover = (annotation) => {
    highlightPeriod(annotation ? annotation.period : undefined);
  };

  const handleCancel = () => {
    if (showAnnotation) {
      setActiveViewKey(LIST_VIEW_KEY);
    } else {
      onClose();
    }
  };

  useEffect(() => {
    if (ids && ids.length) {
      setOpen(true);
    }
  }, [ids]);

  return (
    <SlideBlock open={open} onToggle={handleToggle}>
      {activeViewKey === FORM_VIEW_KEY ? (
        <AnnotationsForm
          initialValues={settings}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      ) : null}
      {activeViewKey === LIST_VIEW_KEY ? (
        <AnnotationList
          items={items || []}
          onCleanSelection={() => selectAnnotations()}
          ids={ids}
          date={date}
          period={period}
          onHover={handleHover}
          onOpenFilters={handleOpenFilters}
        />
      ) : null}
    </SlideBlock>
  );
};

export default Annotations;
